import getInternetMessageIdFromTxpObject from './getInternetMessageIdFromTxpObject';
import { TxpObject } from 'txp-data';

/**
 * If this is a reminder email, we need to get the original internetMessageId from the txpObject
 * otherwise, use the InternetMessageId stamped on the item
 */
export default function getInternetMessageId(
    txpObject: TxpObject,
    internetMessageId: string
): string {
    let reminderEmailInternetMessageId;
    if (txpObject) {
        reminderEmailInternetMessageId = getInternetMessageIdFromTxpObject(txpObject);
        return reminderEmailInternetMessageId || internetMessageId;
    }

    return null;
}
